<template>
  <v-dialog
    :value="value"
    width="500"
    @input="handleInput"
  >
    <v-form @submit.prevent.stop="handleSubmit">
      <v-card>
        <v-toolbar
          flat
          dark
          color="primary"
        >
          {{ $t('Duplicate FAQ') }}
          <v-spacer />
          <v-btn
            icon
            dark
            @click="$emit('input', false)"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-autocomplete
            v-model="form.team_id"
            :error-messages="form.errors.team_id"
            :items="$page.props.user.teams"
            item-text="name"
            item-value="id"
            :label="$t('Duplicate to team')"
            outlined
          />

          <v-text-field
            v-model="form.new_name"
            :loading="form.processing"
            :disabled="form.processing"
            :error-messages="form.errors.new_name"
            :label="$t('New name')"
            :placeholder="`${faq.default_translation.name} *`"
            persistent-placeholder
            outlined
          />

          <v-checkbox
            v-model="form.include_content"
            class="mt-0"
            :label="$t('Include FAQ content')"
            :hint="$t('Categories, Questions, Languages etc.')"
            persistent-hint
            :error-messages="form.errors.include_content"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey"
            text
            @click="$emit('input', false)"
          >
            {{ $t('Cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            text
            type="submit"
            :loading="form.processing"
            :disabled="form.processing"
          >
            {{ $t('Submit') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    faq: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      form: this.$inertia.form({
        new_name: '',
        team_id: this.$page.props.user.current_team.id,
        include_content: false,
      })
    }
  },

  methods: {
    handleInput(value) {
      this.$emit('input', value);

      if (value === false) {
        this.$nextTick(() => {
          this.form.reset();
          this.form.clearErrors();
        });
      }
    },

    handleSubmit() {
      const url = this.route('faq.clone', this.faq.id);

      this.form.post(url, {
        preserveState: false,
        onSuccess: () => {
          this.handleInput(false);
        }
      });
    }
  }
}
</script>